import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SearchStrategyService } from '@services/search-strategy.service';

@Component({
  selector: 'app-filter-website',
  templateUrl: './filter-website.component.html',
  styleUrls: ['./filter-website.component.css'],
  providers: [SearchStrategyService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterWebsiteComponent {
  @Input() filter: any;
  @Input() submitClicked: boolean;
  @Input() readOnly = false;
  formDirty = false;
}
